import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../styles/svgs/errorIcon.svg';

import useStyles from './makeStyles';

const CustomErrorMessage = ({ customErrorCode }) => {
  const classes = useStyles();

  return (
    <div className={classes.notFound}>
      <div>
        <img src={ErrorIcon} alt="Info" className={classes.message_icon} />
        <div
          className={classes.errorMessage}
          dangerouslySetInnerHTML={{
            __html: customErrorCode,
          }}
        />
      </div>
    </div>
  );
};

CustomErrorMessage.propTypes = {
  customErrorCode: PropTypes.string.isRequired,
};

export default CustomErrorMessage;
